/**
Copyright [2022] [https://www.merac.com
 */
const constRouters = [
	{
		path: '/',
		name: 'spaCustomerHome',
		component: () => import('@/views/public/spa-home/index.vue'),
		meta: { title: 'MERAC BALI SPA' }
	},
	{
		path: '/spa',
		redirect: (to) => ({ path: '/', query: to.query, hash: to.hash })
	},
	{
		path: '/findpwd'
	},
	{
		path: '/callback'
	},
	{
		path: '/other',
		name: 'other',
		component: () => import('@/views/other/index.vue'),
		meta: {
			title: '其他'
		}
	},
	{
		path: '/public/review-score',
		name: 'publicReviewScore',
		component: () => import('@/views/public/review-score/index.vue'),
		meta: {
			title: '好评记录与评分'
		}
	},
	{
		path: '/oa/designer',
		name: 'oaWorkflowDesigner',
		component: () => import('@/views/public/oa-designer/index.vue'),
		meta: {
			title: '审批流程设计'
		}
	},
	{
		path: '/pay/sample/doJsPay',
		name: 'doJsPay',
		component: () => import('@/views/pay/sample/doJsPay.vue'),
		meta: {
			title: '微信JSAPI支付'
		}
	}
]
/**
 * 路由白名单（数组形式）
 *
 * 如果组件像登录一样，那就简单的写一个path，即可实现放开，
 * 如果组件不在这边的，需要手动添加组件，就像other一样，
 * 因为没登陆你没法拿到后端给你返回的那一坨，当然就找不到component
 *
 * @author yubaoshan
 */
export default constRouters
